import styled from "styled-components";

export const WrapperMenu = styled.div `
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: ${({theme}) => theme.zIndex.contentFixed};
    overflow: scroll;
    overscroll-behavior: contain;
    padding-bottom: 6.625rem;
`;